import { useCallback } from 'react'
import { OnSubmit } from '../../forms/TwinForm/types'
import { twinFetchPostJSON } from '../globals/data'
import { TwinDictionary } from '../globals/dictionary'

interface FetchJSONProps {
    onSubmit: OnSubmit
    url: string
    data: TwinDictionary
}

export const useFetchJSON = ({ onSubmit, url, data }: FetchJSONProps) => {
    const handleFetchJSON = useCallback(async () => {
        const res = await twinFetchPostJSON(url, {
            ...data
        })
        onSubmit?.(res, data || {})
    }, [onSubmit, url, data])
    return { handleFetchJSON }
}